import { IGetAllFornecedorQualificacaoUseCase } from "../../../presentation/useCases/read/get_all_fornecedor_qualificacao_use_case";
import { FornecedorQualificacao } from "../../models/fornecedor_qualificacao";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAllFornecedorQualificacaoUseCase
 */

export class GetAllFornecedorQualificacaoUseCase implements IGetAllFornecedorQualificacaoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getAllFornecedorQualificacao(
    idFornecedor: number | undefined | null,
  ): Promise<FornecedorQualificacao[]> {
    return await this.repository.getAllFornecedorQualificacao(
      idFornecedor ?? null,
    );
  }
}
